import { Component, inject } from '@angular/core';
import { BaseModalComponent } from "../../../../../../core/components/modals/base-modal/base-modal.component";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { UpdateAccountPhotoDialogData } from "../../../types/telegram-modal.types";
import { MatButton } from "@angular/material/button";
import { FilesService } from "../../../../../../core/services/files.service";
import { UpdateAccountPhotoParams } from "../../../types/telegram-page.types";
import { TelegramUpdateAccountPhotoService } from "../../../services/telegram-update-account-photo.service";
import {
  FileProgressBarStatusComponent
} from "../../../../../../shared/components/ui/file-progress-bar-status/file-progress-bar-status.component";
import { telegramUpdateAccountPhotoModalName } from "./configs/telegram-update-account-photo-config";

@Component({
  selector: 'app-telegram-update-account-photo-modal',
  standalone: true,
  imports: [
    BaseModalComponent,
    MatButton,
    FileProgressBarStatusComponent
  ],
  templateUrl: './telegram-update-account-photo-modal.component.html',
  styleUrl: './telegram-update-account-photo-modal.component.scss'
})
export class TelegramUpdateAccountPhotoModalComponent extends BaseModalComponent {
  private dialogData = inject<UpdateAccountPhotoDialogData>(MAT_DIALOG_DATA);
  private telegramUpdateAccountPhotoService: TelegramUpdateAccountPhotoService = inject(TelegramUpdateAccountPhotoService);
  private filesService: FilesService = inject(FilesService);

  public allowMultipleFiles = false;
  public selectedFiles: Array<File> = [];
  public isHover: boolean = false;

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(telegramUpdateAccountPhotoModalName);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(telegramUpdateAccountPhotoModalName);
  }

  public handleFileDropped(event: DragEvent): void {
    event.preventDefault();
    this.isHover = false;
    const files = event.dataTransfer?.files;
    if (!files?.length) {
      this.selectedFiles = [];
      return;
    }

    const file = files[0]

    if (!this.telegramUpdateAccountPhotoService.validateFile(file)) {
      this.selectedFiles = [];
      return;
    }

    this.selectedFiles.push(file);
  }

  public handleDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isHover = true;
  }

  public handleDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isHover = false;
  }

  public handleFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = input?.files;
    if (!files?.length) { return; }

    const file = files[0];
    if (!this.telegramUpdateAccountPhotoService.validateFile(file)) {
      input.files = null;
      this.selectedFiles = [];
      return;
    }

    this.selectedFiles.push(file);
  }

  public async handleUpdatePhoto(): Promise<void> {
    if (!this.selectedFiles.length) { return; }

    const formData = this.filesService.createFormData({
      file: this.selectedFiles[0],
      fileType: 'image'
    });

    const updateAccountPhotoParams: UpdateAccountPhotoParams = {
      image: formData,
      accountId: this.dialogData.accountId,
      fileName: this.selectedFiles[0].name
    };

    await this.telegramUpdateAccountPhotoService.updateAccountPhoto(updateAccountPhotoParams)
      .then(() => {
        this.snackbarService.showMessage({ message: 'Фото успешно обновлено!' });
        this.closeDialog('success')
      })
      .catch(() => this.closeDialog('cancel'));
  }
}
